import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import './HeroSection.css';

const HeroSection = ({
  title,
  subtitle,
  children,
  variant = 'centered',
  ctaButtonText,
  ctaDescription,
  ctaLink,
  ctaButtonLabel = 'Create Account',
  ctaNote
}) => {
  return (
    <section className={`hero-section hero-section--${variant}`}>
      <div className="hero-section-container">
        <div className="hero-section-content">
          <h1 className="hero-section-title">{title}</h1>
          <p className="hero-section-subtitle">{subtitle}</p>
        </div>
        {ctaButtonText && ctaLink && (
          <div className="hero-section-cta">
            <div className="hero-cta-card">
              <div className="hero-cta-content">
                <span className="hero-cta-title">{ctaButtonText}</span>
                {ctaDescription && (
                  <span className="hero-cta-description">{ctaDescription}</span>
                )}
                <Button
                  variant="primary"
                  size="large"
                  href={ctaLink}
                  className="hero-cta-button"
                >
                  {ctaButtonLabel}
                </Button>
                {ctaNote && <span className="hero-cta-note">{ctaNote}</span>}
              </div>
            </div>
          </div>
        )}
        {children && (
          <div className="hero-section-additional">
            {children}
          </div>
        )}
      </div>
    </section>
  );
};

HeroSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.node,
  variant: PropTypes.oneOf(['centered', 'split']),
  ctaButtonText: PropTypes.string,
  ctaDescription: PropTypes.string,
  ctaLink: PropTypes.string,
  ctaButtonLabel: PropTypes.string,
  ctaNote: PropTypes.string
};

export default HeroSection;
